import { funlidayRequest } from './main';
import { SOCIAL_TYPE } from '../constants/social';
import { getClientId } from '../utilities/uuid_util';

/** @methods setLike - 按讚或取消讚
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 該 journal、trip、collection、article 的作者 userid
 * @param {String} param.id (Required) 該 journal、trip、collection、article 的 id
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {Boolean} param.status (Required) 按讚 (true) 或取消讚 (false)
 * @returns {Promise} axiosPromise
 */
export const setLike = ({ userid, id, type, status }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
    status,
  };
  return funlidayRequest.post('socialLike', params);
};

/** @methods socialDeleteComment - 刪除指定留言
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {Number} param.commentId (Required) 該留言本身留言編號 ID
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @returns {Promise} axiosPromise
 */
export const socialDeleteComment = ({ commentId, userid, id, type }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
    commentId: Number(commentId),
  };
  return funlidayRequest.post('socialDeleteComment', params);
};

/** @methods socialGetCommentDetail - 取得指定留言的第二層回覆留言
 * @param {Object} param (Required) 傳入解構的物件參數
 * @param {Number} param.commentId (Required) 該留言本身留言編號 ID
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {String} param.offset (Optional) 要向後端取資料時略過既有不取的筆數
 * @param {String} param.limit (Optional) 要向後端取資料時的筆數限制
 * @returns {Promise} axiosPromise
 */
export const socialGetCommentDetail = ({
  commentId,
  userid,
  id,
  type,
  offset,
  limit,
}) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
    commentId: Number(commentId),
  };
  if (offset) params.offset = offset;
  if (limit) params.limit = limit;
  return funlidayRequest.post('socialGetCommentDetail', params);
};

/** @methods socialGetCommentList - 取得留言列表
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {String} param.offset (Optional) 要向後端取資料時略過既有不取的筆數
 * @param {String} param.limit (Optional) 要向後端取資料時的筆數限制
 * @returns {Promise} axiosPromise
 */
export const socialGetCommentList = ({ userid, id, type, offset, limit }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
  };
  if (offset) params.offset = offset;
  if (limit) params.limit = limit;
  return funlidayRequest.post('socialGetCommentList', params);
};

/** @methods socialGetLikeList - 取得按讚列表
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @returns {Promise} axiosPromise
 */
export const socialGetLikeList = ({ userid, id, type }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
  };
  return funlidayRequest.post('socialGetLikeList', params);
};

/** @methods socialLeaveComment - 留言
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {String} param.content (Required) 留言內容
 * @returns {Promise} axiosPromise
 */
export const socialLeaveComment = ({ userid, id, type, content }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
    content,
  };
  return funlidayRequest.post('socialLeaveComment', params);
};

/** @methods socialLeaveReply - 在留言下回覆
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 該頁在 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 該頁所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {String} param.content (Required) 回覆內容
 * @param {Number} param.commentId (Required) 欲回覆的所屬留言 ID
 * @returns {Promise} axiosPromise
 */
export const socialLeaveReply = ({ userid, id, type, commentId, content }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type: Number(type),
    commentId: Number(commentId),
    content,
  };
  return funlidayRequest.post('socialLeaveReply', params);
};

/** @methods socialCopy - 複製(journal、trip、collection、article..etc）
 * @param {Object} param (Required)傳入近來解構的參數物件
 * @param {String} param.userid (Required) 欲複製目標所屬 journal、trip、collection、article ..etc 的作者 userID
 * @param {String} param.id (Required) 欲複製目標所屬 journal、trip、collection、article ..etc 的 ID
 * @param {Number} param.type (Required) 帶入整數 1~5，對應 journal (1)、trip (2)、collection (4)、article (5) 的 social type
 * @param {String} param.name (Required) 欲複製時設定的名稱
 * @param {String} param.startDate (Optional) 欲複製時設定的時間(給有時間功能例如複製 trip 時用的) 時間格式現改為 20200101 而非是 2020-01-01
 * @returns {Promise} axiosPromise
 */
export const socialCopy = ({ userid, id, type, name, startDate }) => {
  const params = {
    userid: String(userid),
    id: String(id),
    type,
    name: String(name),
  };
  if (startDate) {
    if (startDate.indexOf('-') > -1) {
      let newStartDate = '';
      startDate.split('-').forEach(item => {
        newStartDate += item;
      });
      params.startDate = newStartDate;
    } else {
      params.startDate = startDate;
    }
  }
  return funlidayRequest.post('socialCopy', params);
};
